import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
}));

function BackButton(props) {
  const { history } = props;
  const classes = useStyles();

  function handleClick() {
    history.goBack();
  }
  return (
    <Grid item xs={12} classes={{ root: classes.root }}>
      <Fab color="secondary" variant="extended" size="medium" onClick={handleClick}>
        <ChevronLeftIcon />
        Regresar
      </Fab>
    </Grid>
  );
}

BackButton.propTypes = propTypes;

export default withRouter(BackButton);
